/**
 * The two capped values a content-search count can come back as. They are one
 * apart and they do not mean the same thing, which is the whole reason they
 * live together in one file rather than as magic numbers at the places that
 * read them.
 *
 * Both mirror Rust constants in
 * `services/libs/graphql/src/schema/content/content_search_queries.rs`
 * (`COUNT_ROW_CAP` and `GAVE_UP_COUNT`). — Claude
 */

/** The count query reached its row limit: there are at least this many. */
export const COUNT_CAP = 10_001

/**
 * The count query ran out of its ten-second budget and the server stopped
 * waiting. Renders as "10,000+" like the cap, but it is not a number anything
 * finished producing — only a diagnostic readout should tell them apart.
 */
export const COUNT_GAVE_UP = 10_002

/**
 * Renders a count for display, as "10,000+" once it reaches the cap.
 *
 * Shared rather than inlined at each call site because the cap is the query's
 * behaviour, not the component's: a screen that prints a bare 10001 is claiming
 * a precision the count never had. Pagination does the same thing for the feed;
 * this is for the screens that show a total on its own. — Claude
 */
export function formatCappedCount(total: number): string {
    return total >= COUNT_CAP ? '10,000+' : total.toLocaleString()
}
